import FlexbaseHttp from './api';

export interface Document {
    bucket: string;
    id: string;
    key: string;
    url: string;
    title: string;
    token: string;
    created_at: string;
}

export interface DocumentPayload {
    url: string,
    s3Key: string,
    fileName: string,
    fileType: string,
    fileSize: number,
}

export default class DocumentService {
    presignUrl: string;

    persistUrl: string;

    constructor(presignUrl?: string, uploadUrl?: string) {
      this.presignUrl = presignUrl || '/common/create-presigned-post/';
      this.persistUrl = uploadUrl || '/automatic/documents/';
    }

    async uploadDocument(file: File): Promise<Document> {
      const preSignedUrlData = await this.generatePresignedUrl(file.name);

      return this.uploadFileToS3(preSignedUrlData, file).then(() => this.persistFile({
        url: preSignedUrlData.url,
        s3Key: preSignedUrlData.s3Headers.fields.key,
        fileName: file.name,
        fileType: file.type,
        fileSize: file.size,
      }),);
    }

    uploadDocuments(files: Array<File>): Promise<Array<Document>> {
      return Promise.all(
        files.map((file) => this.uploadDocument(file).catch((e) => {
          throw new Error(`Upload failed for ${file.name}: ${e.message}`);
        }),),
      );
    }

    generatePresignedUrl(filename: string): Promise<Record<string, any>> {
      return new FlexbaseHttp(this.presignUrl, { filename }).post();
    }

    persistFile(documentPayload: DocumentPayload): Promise<Document> {
      return new FlexbaseHttp(this.persistUrl, documentPayload).post().then((response) => response);
    }

    // eslint-disable-next-line class-methods-use-this
    uploadFileToS3(presignedPostData: Record<string, any>, file: File): Promise<any> {
      const formData = new FormData();
      Object.keys(presignedPostData.s3Headers.fields).forEach((key) => {
        formData.append(key, presignedPostData.s3Headers.fields[key]);
      });
      // Actual file has to be appended last.
      formData.append('file', file);
      return fetch(presignedPostData.s3Headers.url, {
        method: 'POST',
        body: formData,
        mode: 'no-cors',
      });
    }

    deleteDocument(documentId: string) {
      return new FlexbaseHttp(`${this.persistUrl}${documentId}/`).delete();
    }
}
